module.exports = __webpack_public_path__ + "img/icon-building-green-old.04222c98.svg";